"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdColorPicker = require("cccisd-color-picker");
var _cccisdFormik = require("cccisd-formik");
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _InlineWysiwyg = _interopRequireDefault(require("./InlineWysiwyg"));
var _SectionTitle = _interopRequireDefault(require("./SectionTitle"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var IconAndDescription = function IconAndDescription(props) {
  var heading = props.heading,
    name = props.name,
    formProps = props.formProps,
    DefaultIcon = props.DefaultIcon;
  var setImageDetails = function setImageDetails(img) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, _defineProperty({}, name, _objectSpread(_objectSpread({}, formProps.values.courseDescription[name]), {}, {
        imageDetails: img
      })))
    }));
  };
  var _formProps$values$cou = formProps.values.courseDescription[name],
    iconSelection = _formProps$values$cou.icon,
    iconColor = _formProps$values$cou.iconColor,
    imageDetails = _formProps$values$cou.imageDetails;
  var validateImageDimensions = function validateImageDimensions() {
    if (!imageDetails || !imageDetails.metadata) {
      return;
    }
    // Image will be a centered, cover background with
    // width of 30px and height of 30px (), so this
    // checks that it will not be cropped undexpectedly
    var _imageDetails$metadat = imageDetails.metadata,
      width = _imageDetails$metadat.width,
      height = _imageDetails$metadat.height;
    var ratio = width / height;
    return ratio < 1.05 && ratio > 0.95;
  };
  var getTitlePlaceholder = function getTitlePlaceholder() {
    if (name === 'audience') return 'Audience';
    if (name === 'creditHours') return 'Credit Hours';
    if (name === 'duration') return 'Duration';
    return name;
  };
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, heading), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
    name: name,
    placeholder: getTitlePlaceholder()
  }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
    name: "courseDescription.".concat(name, ".description"),
    label: "Description"
  }), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "courseDescription.".concat(name, ".icon")
  }, "Icon"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].iconAndDescriptionRadio, " form-group")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].iconRadioGroup
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "radio"
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    type: "radio",
    name: "courseDescription.".concat(name, ".icon"),
    value: "default",
    checked: iconSelection === 'default'
  }), "Default icon")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "radio"
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    type: "radio",
    name: "courseDescription.".concat(name, ".icon"),
    value: "none",
    checked: iconSelection === 'none'
  }), "No icon")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "radio"
  }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    type: "radio",
    name: "courseDescription.".concat(name, ".icon"),
    value: "upload",
    checked: iconSelection === 'upload'
  }), "Upload icon"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].iconContainer
  }, iconSelection === 'default' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: (0, _cccisdColorPicker.getColor)(iconColor)
    }
  }, /*#__PURE__*/_react["default"].createElement(DefaultIcon, null)), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "courseDescription.".concat(name, ".iconColor"),
    component: _cccisdFormik.CccisdColorPicker
  })), iconSelection === 'upload' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, imageDetails && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].bgImage,
    style: {
      backgroundImage: "url(\"".concat(imageDetails.url, "\")")
    }
  }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
    onChange: setImageDetails,
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-default"
    }, imageDetails ? 'Change icon' : 'Select icon')
  })))), imageDetails && !validateImageDimensions() && /*#__PURE__*/_react["default"].createElement("p", {
    className: "bg-warning"
  }, /*#__PURE__*/_react["default"].createElement("small", null, "Note: Ideal image dimensions are 60px (w) by 60px (h). Please verify thumbnail.")));
};
var _default = IconAndDescription;
exports["default"] = _default;